import { Directive, ElementRef, input, OnInit, inject } from '@angular/core';

@Directive({ selector: '[autofocus]' })
export class AutofocusDirective implements OnInit {
  private el = inject(ElementRef);

  autofocus = input<boolean | undefined>(undefined);

  ngOnInit() {
    if (this.autofocus() !== false) this.el.nativeElement.focus();
  }
}
